export const EXECUTION_PROFILES = ["passive", "balanced", "aggressive", "twap", "vwap", "pov"];
export const EXECUTION_VENUE_IDS = ["moex", "spb", "otc"];
export const EXECUTION_TRACE_CAUSAL_STAGES = ["signal", "risk_gate", "router", "venue"];
